import React from 'react';
import { Tab, Tabs } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import CodeIcon from '@mui/icons-material/Code';
import SendIcon from '@mui/icons-material/Send';
import HistoryIcon from '@mui/icons-material/History';
import StorageIcon from '@mui/icons-material/Storage';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  DETAIL_PANEL_TAB_DEALER_360,
  DETAIL_PANEL_TAB_SELECTIONS,
  DETAIL_PANEL_TAB_RAW_JSON,
  DETAIL_PANEL_TAB_EDIT_AND_SEND,
  DETAIL_PANEL_TAB_HISTORY,
  DETAIL_PANEL_TAB_APPSHEET,
  DETAIL_PANEL_TAB_TRADE,
} from '../constants/detailPanelTabs';

// DetailPanelTabs defines the canonical navigation contract for the dealer detail
// drawer. Tab order matters because operators treat the leftmost tabs as the
// default review flow and the later tabs as deeper audit/mutation surfaces.
const DetailPanelTabs = ({ value, onChange }) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      textColor="primary"
      indicatorColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
    >
      <Tab value={DETAIL_PANEL_TAB_SELECTIONS} label="Selections" icon={<TableChartIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_APPSHEET} label="AppSheet" icon={<StorageIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_TRADE} label="Trade" icon={<StorageIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_RAW_JSON} label="Raw JSON" icon={<CodeIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_EDIT_AND_SEND} label="Edit & Send" icon={<SendIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_HISTORY} label="History" icon={<HistoryIcon />} iconPosition="start" />
      <Tab value={DETAIL_PANEL_TAB_DEALER_360} label="Dealer 360" icon={<OpenInNewIcon />} iconPosition="start" />
    </Tabs>
  );
};

export default DetailPanelTabs;
export {
  DETAIL_PANEL_TAB_DEALER_360,
  DETAIL_PANEL_TAB_SELECTIONS,
  DETAIL_PANEL_TAB_RAW_JSON,
  DETAIL_PANEL_TAB_EDIT_AND_SEND,
  DETAIL_PANEL_TAB_HISTORY,
  DETAIL_PANEL_TAB_APPSHEET,
  DETAIL_PANEL_TAB_TRADE,
};
